export default {"src":"/_next/static/media/house-icon.7011161b.svg","height":16,"width":16};